import { query } from '../utilities';

export const cashbackOrderSpend = () => {
    return query('/order/cashback-order-info/', {});
};
